import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a9620f4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a9620f4c&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=a9620f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9620f4c",
  null
  
)

export default component.exports